import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function GovernmentAgencies() {
    return (
        <main className="bg-gradient-to-b from-slate-900 to-black text-gray-100 py-16 overflow-hidden">
            <section className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row items-center gap-12">
                <motion.div
                    className="flex-1 flex justify-center order-2 lg:order-1"
                    initial={{ opacity: 0, x: -200 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1.2 }}
                >
                    <img
                        src="/Images/industry-government.jpg"
                        alt="Government agency illustration"
                        className="w-[90%] max-w-md rounded-2xl shadow-2xl"
                    />
                </motion.div>

                <div className="flex-1 z-10 order-1 lg:order-2">
                    <h1 className="text-4xl font-bold text-white">Government & Agencies</h1>
                    <p className="mt-4 text-lg text-gray-300 leading-relaxed">
                        SecureID Technologies delivers biometric identity and testing solutions
                        for city, county, and federal agencies. Our FDLE and FBI-compliant
                        integrations enable fast and secure data exchange between departments.
                    </p>

                    <ul className="mt-6 list-disc pl-6 text-gray-300 space-y-2">
                        <li>FDLE / FBI background screening integrations</li>
                        <li>On-site and remote Live Scan enrollment</li>
                        <li>Role-based system access and auditing</li>
                        <li>Secure cloud transmission and retention</li>
                    </ul>

                    <p className="mt-10 text-sm text-gray-400">
                        <Link to="/" className="text-indigo-400 hover:underline">
                            ← Back to Home
                        </Link>
                    </p>
                </div>
            </section>
        </main>
    );
}
